import React from "react";
import Banner from "../components/Banner";
import FilmList from "../components/FilmList";

const Moi = () => {
    return (
        <div className="moi">
        <Banner />
        <FilmList />   
        </div>
    )

}

export default Moi;
